import styled from 'styled-components';

const ContentContainer = styled.div`
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`;

export default ContentContainer;
